import React from 'react';
import './ContactPage.css'; // We'll create this CSS file next
import contactHeroImage from "../Assets/cont1.png"

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* Hero Image Section */}
      <div className="contact-hero">
        <img 
          src={contactHeroImage} 
          alt="Parity Empowerment Initiative Team" 
          className="contact-hero-image"
        />
      </div>

      <div className="contact-header">
        <h1>Get In Touch</h1>
        <p>We'd love to hear from you! Reach out through any of these channels.</p>
      </div>

      <div className="contact-container">
        <div className="contact-card">
          <div className="contact-method">
            <div className="contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>
            </div>
            <div className="contact-details">
              <h3>Email</h3>
              <a href="mailto:Parityempowermentinitiative@gmail.com">parityempowermentinitiative@outlook.com</a>
            </div>
          </div>

          <div className="contact-method">
            <div className="contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="contact-details">
              <h3>Location</h3>
              <p>Kampala, Hoima & Gayaza - Uganda</p>
            </div>
          </div>

          <div className="contact-method">
            <div className="contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fillRule="evenodd" d="M19.902 4.098a3.75 3.75 0 00-5.304 0l-4.5 4.5a3.75 3.75 0 001.035 6.037.75.75 0 01-.646 1.353 5.25 5.25 0 01-1.449-8.45l4.5-4.5a5.25 5.25 0 117.424 7.424l-1.757 1.757a.75.75 0 11-1.06-1.06l1.757-1.757a3.75 3.75 0 000-5.304zm-7.389 4.267a.75.75 0 011-.353 5.25 5.25 0 011.449 8.45l-4.5 4.5a5.25 5.25 0 11-7.424-7.424l1.757-1.757a.75.75 0 111.06 1.06l-1.757 1.757a3.75 3.75 0 105.304 5.304l4.5-4.5a3.75 3.75 0 00-1.035-6.037.75.75 0 01-.354-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="contact-details">
              <h3>Online</h3>
              <a href="https://linktr.ee/Parityempowermentinitiative" target="_blank" rel="noopener noreferrer">
                Linktree Profile
              </a>
            </div> <br/>

          </div>
        </div>

        <div className="slogan-section">
          <h2>Every Change Matters</h2>
          <p>Your connection with us helps drive our mission forward.</p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;